import {
  MessageOutlined as MessageOutlinedIcon,
  Send as SendIcon,
  AutoAwesome as AISuggestionIcon,
} from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { LoadingButton } from '@mui/lab';
import {
  Avatar,
  Box,
  Card,
  Grid,
  IconButton,
  Paper,
  Stack,
  ListItemButton,
  TextField,
  ListItemText,
  List,
  Menu,
  ListItem,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Rating from '@mui/material/Rating';
import { useTheme } from '@mui/material/styles';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import TextIconLabel from 'src/components/TextIconLabel';
import HttpServices from 'src/services/httpService';
import { postsModuleURL, userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import Spinner from 'src/utils/Loader/spinner';
import ThreeDotLoader from 'src/utils/Loader/threeDotLoader.compontent';
import { useToaster } from 'src/utils/toaster/toasterContext';
import { useResellerLimitDialog } from 'src/components/reseller-limit-context/resellerLimitContext';
import NoMessage from '../../assets/app-image/no-message.svg';
import DeleteCommentIcon from '../../assets/deletecomment.svg';

const ReviewsGrid = ({ gBusinessId }) => {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const childCommentInputRef = useRef(null);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { showToast } = useToaster();
  const { showResellerLimitDialog } = useResellerLimitDialog();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [height, setHeight] = useState(window.innerHeight - 260);
  const [isLoading, setLoading] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [childComment, setChildComment] = useState('');
  const [childCommentId, setChildCommentId] = useState(null);
  const [isSendLoading, setSendLoading] = useState(false);
  const [pagination, setPagination] = useState('');
  const [loaderReviews, setLoaderReviews] = useState(false);
  const [aiSuggestions, setAiSuggestions] = useState([]);
  const [aiSuggestionAnchorEl, setAiSuggestionAnchorEl] = useState(null);
  const [aiSuggestionCommentId, setAiSuggestionCommentId] = useState('');
  const [isFetchingSuggestions, setIsFetchingSuggestions] = useState(false);
  const hasManageLikesCommentPermission = CommonHelper.CheckForPermissionAvailableForUser(
    CommonHelper.PermissionList.MANAGE_COMMENTS_LIKES
  );

  useEffect(() => {
    if (gBusinessId) {
      getGBusinessReview();
    }
  }, [gBusinessId]);

  const getGBusinessReviewSuccessCallback = (data, message) => {
    setReviews(data.reviews);
    setPagination(data.pagination);
    setLoading(false);
  };
  const getNextGBusinessReviewSuccessCallback = (data, message) => {
    setLoaderReviews(false);
    let updatedReviewss = [...reviews, ...data.reviews];
    setReviews(updatedReviewss);
    setPagination(data.pagination);
  };
  const addReviewSuccessCallback = (data, message) => {
    const updatedReviews = reviews.map((review) => {
      if (review.reviewId === childCommentId) {
        return { ...review, reviewReply: { comment: childComment, updateTime: new Date() } };
      }
      return review;
    });
    setReviews(updatedReviews);
    setSendLoading(false);
    setChildComment('');
    setChildCommentId(null);
  };
  const deleteReviewSuccessCallback = (data, message) => {
    setChildComment('');
    setChildCommentId(null);
    setSendLoading(false);
  };

  const addReviewFailureCallback = (message) => {
    message && showToast(message, 'e');
    setLoading(false);
    setSendLoading(false);
  };

  const getGBusinessReviewFailureCallback = (message) => {
    setReviews([]);
    message && showToast(message, 'e');
    setLoading(false);
    setLoaderReviews(false);
    setChildComment('');
    setChildCommentId(null);
  };

  const getGBusinessReview = () => {
    setLoading(true);
    let getProps = {
      url: postsModuleURL.fetchAllReviews + gBusinessId,
      successCallback: getGBusinessReviewSuccessCallback,
      failureCallback: getGBusinessReviewFailureCallback,
    };
    HttpServices.Get(getProps);
  };
  const getNextGBusinessReview = () => {
    setLoaderReviews(true);
    let getProps = {
      url: `${postsModuleURL.fetchAllReviews}${gBusinessId}&pagination=${pagination}`,
      successCallback: getNextGBusinessReviewSuccessCallback,
      failureCallback: getGBusinessReviewFailureCallback,
    };
    HttpServices.Get(getProps);
  };

  const handleClickComment = (comment) => {
    if (comment.reviewReply) return;
    setChildComment('');
    setChildCommentId(comment.reviewId);
  };

  const handleClickEditComment = (comment) => {
    setChildComment(comment.reviewReply.comment);
    setChildCommentId(comment.reviewId);
  };

  const handlePostComment = (comnt, isParent) => {
    setChildComment(comnt);
    setSendLoading(true);
    let postCommentBody = {
      connected_profile_id: gBusinessId,
      review_id: childCommentId,
      message: comnt,
    };
    let postProps = {
      url: postsModuleURL.addReviews,
      body: postCommentBody,
      successCallback: addReviewSuccessCallback,
      failureCallback: addReviewFailureCallback,
    };
    HttpServices.Post(postProps);
  };

  const handleDeleteReview = (id) => {
    setSendLoading(true);
    let postCommentBody = {
      connected_profile_id: gBusinessId,
      review_id: id,
    };
    let postProps = {
      url: postsModuleURL.deleteReviews,
      body: postCommentBody,
      successCallback: deleteReviewSuccessCallback,
      failureCallback: addReviewFailureCallback,
    };
    const updatedReviews = reviews.map((review) => {
      if (review.reviewId === id) {
        const { reviewReply, ...rest } = review;
        return rest;
      }
      return review;
    });
    setReviews(updatedReviews);
    HttpServices.Post(postProps);
  };

  const handleChangeComment = (e) => {
    setChildComment(e.target.value);
  };
  const RatingValue = (value) => {
    let rate = 0;
    switch (value) {
      case 'FIVE':
        rate = 5;
        break;
      case 'FOUR':
        rate = 4;
        break;
      case 'THREE':
        rate = 3;
        break;
      case 'TWO':
        rate = 2;
        break;
      case 'ONE':
        rate = 1;
        break;
      default:
        break;
    }
    return rate;
  };
  const handleFetchAiSuggestions = (review, event) => {
    if (!hasManageLikesCommentPermission) return;
    setIsFetchingSuggestions(true);
    setAiSuggestionCommentId(review.reviewId);
    setAiSuggestionAnchorEl(event.currentTarget);

    const bodyProps = {
      question: review.comment, // Use review.comment instead of comment.text
    };

    const postProps = {
      url: userModuleURL.getAiSuggestionMessage,
      body: bodyProps,
      successCallback: (data, message) => {
        setAiSuggestions(data.suggestions || []);
        setIsFetchingSuggestions(false);
      },
      failureCallback: (message) => {
        setAiSuggestions([]);
        setIsFetchingSuggestions(false);
        setAiSuggestionAnchorEl(null);
        if (!showResellerLimitDialog(message)) {
           message && showToast(message, 'e');
        }
      },
    };

    HttpServices.Post(postProps);
  };

  const handleSelectAiSuggestion = (suggestion) => {
    setChildComment(suggestion);
    setChildCommentId(aiSuggestionCommentId);
    setAiSuggestionAnchorEl(null);
    setAiSuggestions([]);
    setAiSuggestionCommentId('');
    childCommentInputRef.current?.focus();
  };
  const AISuggestionMenu = ({ reviewId }) => (
    <Menu
      anchorEl={aiSuggestionAnchorEl}
      open={Boolean(aiSuggestionAnchorEl) && aiSuggestionCommentId === reviewId}
      onClose={() => {
        setAiSuggestionAnchorEl(null);
        setAiSuggestions([]);
        setAiSuggestionCommentId('');
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          maxHeight: 300, // Limit menu height
          width: '300px',
        },
      }}
    >
      {isFetchingSuggestions ? (
        <ListItem
          disableGutters
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            px: 2,
            py: 2.5,
            backgroundColor: theme.palette.background.paper,
            borderRadius: 1,
            boxShadow: '0px 2px 8px rgba(0,0,0,0.05)',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: 600,
              color: theme.palette.primary.main,
              letterSpacing: 0.5,
              mb: 0.5,
            }}
          >
            {translate('ai_message_comments.generating_replies')}
          </Typography>
          <ThreeDotLoader
            sx={{
              color: theme.palette.primary.light,
              fontSize: '1.5rem',
            }}
          />
        </ListItem>
      ) : aiSuggestions.length > 0 ? (
        <List sx={{ maxWidth: 300 }}>
          {aiSuggestions.map((suggestion, index) => (
            <ListItemButton
              key={index}
              onClick={() => handleSelectAiSuggestion(suggestion)}
              sx={{
                borderBottom: index < aiSuggestions.length - 1 ? `1px solid ${theme.palette.grey[300]}` : 'none',
                py: 1.5,
              }}
            >
              <ListItemText
                primary={suggestion}
                primaryTypographyProps={{
                  variant: 'body2',
                  sx: { whiteSpace: 'normal', wordBreak: 'break-word' },
                }}
              />
            </ListItemButton>
          ))}
        </List>
      ) : (
        <ListItem>
          <ListItemText primary={translate('ai_message_comments.no_ai_suggestions')} />
        </ListItem>
      )}
    </Menu>
  );
  const commentView = (review) => (
    <Stack key={review.reviewId} direction="row" spacing={2} style={{ marginLeft: 15, marginRight: 15, padding: 5 }}>
      <Avatar alt={review.reviewer.displayName} src={review.reviewer.profilePhotoUrl} />
      <Paper sx={{ p: 1.5, flexGrow: 1, bgcolor: 'background.neutral', margin: '10px', boxShadow: '3' }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ sm: 'center' }}
          justifyContent="space-between"
          sx={{ mb: 0.5 }}
        >
          <Typography variant="subtitle2">{review.reviewer.displayName}</Typography>
          <Typography variant="caption" sx={{ color: 'text.disabled' }}>
            {CommonHelper.DateTimeFromCurrentTime(review.createTime)}
          </Typography>
        </Stack>
        <Rating name="read-only" value={RatingValue(review.starRating)} readOnly />
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {review.comment}
        </Typography>
        <Stack
          flexWrap="wrap"
          direction="row"
          justifyContent="flex-end"
          spacing={1}
          sx={{
            mt: 3,
            color: 'text.disabled',
          }}
        >
          <IconButton
            onClick={(e) => handleFetchAiSuggestions(review, e)}
            disabled={!hasManageLikesCommentPermission || isFetchingSuggestions}
          >
            <TextIconLabel
              aria-label="ai-suggestion"
              sx={{ typography: 'subtitle2' }}
              icon={
                <AISuggestionIcon
                  sx={{
                    width: 20,
                    height: 20,
                    color: isFetchingSuggestions ? theme.palette.grey[400] : theme.palette.primary.main,
                  }}
                />
              }
            />
          </IconButton>
          <IconButton onClick={() => handleClickComment(review)}>
            <MessageOutlinedIcon
              sx={{ width: 20, height: 20, mr: 0.5, color: theme.palette.preview.comments.facebook }}
            />
          </IconButton>
        </Stack>
      </Paper>
      <AISuggestionMenu reviewId={review.reviewId} />
    </Stack>
  );
  const commentReplyView = (review) => {
    return (
      <Stack key={review.reviewId} direction="row" spacing={2} style={{ marginLeft: 15, marginRight: 15, padding: 5 }}>
        <Avatar />
        <Paper sx={{ p: 1.5, flexGrow: 1, bgcolor: 'background.neutral', margin: '10px', boxShadow: '3' }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ sm: 'center' }}
            justifyContent="space-between"
            sx={{ mb: 0.5 }}
          >
            <Typography variant="subtitle2">{translate('preview.author')}</Typography>
            <Typography variant="caption" sx={{ color: 'text.disabled' }}>
              {CommonHelper.DateTimeFromCurrentTime(review.reviewReply.updateTime)}
            </Typography>
          </Stack>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {review.reviewReply.comment}
          </Typography>
          <Stack
            flexWrap="wrap"
            direction="row"
            justifyContent="flex-end"
            spacing={1}
            sx={{
              mt: 3,
              color: 'text.disabled',
            }}
          >
            <IconButton onClick={() => handleClickEditComment(review)}>
              <EditIcon sx={{ width: 20, height: 20, mr: 0.5, color: theme.palette.primary.main }} />
            </IconButton>
            <IconButton onClick={() => handleDeleteReview(review.reviewId)}>
              <img src={DeleteCommentIcon} style={{ width: 20, height: 20 }} />
            </IconButton>
          </Stack>
        </Paper>
      </Stack>
    );
  };

  const writeContentView = (id, comment, isParent = false) => {
    return (
      <Card sx={{ boxShadow: 'none', marginLeft: isParent ? '0px' : '80px !important' }}>
        <Stack direction="row" alignItems="center" sx={{ mt: '10px' }}>
          <TextField
            fullWidth
            size="small"
            value={comment}
            placeholder={translate('reviews_questions.write_a_comment')}
            onChange={(e) => {
              handleChangeComment(e, isParent);
            }}
            sx={{
              ml: 2,
              mr: 1,
              '& fieldset': {
                borderWidth: `1px !important`,
                borderColor: (theme) => `${theme.palette.grey[500_32]} !important`,
              },
            }}
          />
          <LoadingButton
            variant="outlined"
            loading={isSendLoading}
            endIcon={<SendIcon />}
            size=""
            onClick={() => {
              handlePostComment(comment, isParent);
            }}
            disabled={!comment}
            sx={{
              border: 'none',
              '&.Mui-disabled': {
                border: 'none',
                opacity: 0.6,
              },
              '&.MuiLoadingButton-root:hover': {
                border: 'none',
                background: 'none',
              },
            }}
          ></LoadingButton>
          <input type="file" ref={fileInputRef} style={{ display: 'none' }} />
        </Stack>
      </Card>
    );
  };

  const getGridView = () => {
    return (
      <Grid sx={{ maxHeight: 'calc(100vh - 360px)', overflow: 'auto' }}>
        <Stack>
          {reviews &&
            reviews.length > 0 &&
            reviews.map((review) => (
              <>
                <Card sx={{ m: '10px !important', boxShadow: 'none' }}>{commentView(review)}</Card>
                {review.reviewReply && (
                  <Card sx={{ marginLeft: '80px !important', boxShadow: 'none' }}>{commentReplyView(review)}</Card>
                )}
                {childCommentId && review.reviewId === childCommentId && writeContentView(childCommentId, childComment)}
              </>
            ))}
          {pagination !== '' && (
            <Box sx={{ textAlign: 'center', marginRight: '12rem !important' }}>
              {loaderReviews ? (
                <ThreeDotLoader />
              ) : (
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 700,
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    color: theme.palette.grey[500],
                  }}
                  onClick={getNextGBusinessReview}
                >
                  {translate('reviews_questions.load_more_reviews')}
                </Typography>
              )}
            </Box>
          )}
        </Stack>
      </Grid>
    );
  };

  return (
    <Box>
      <>
        {isLoading ? (
          <Spinner height={height} />
        ) : reviews?.length > 0 ? (
          getGridView()
        ) : (
          <Box
            sx={{
              mb: 2,
              p: 2,
              maxHeight: 'calc(100vh - 360px)',
              minHeight: 'calc(100vh - 360px)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={NoMessage}
              style={{ width: '25%', height: '25%', maxWidth: '25%', maxHeight: '25%' }}
              alt="No Message Available"
            />
            <Typography variant="h4" sx={{ fontWeight: 800 }}>
              {translate('reviews_questions.no_reviews_available')}
            </Typography>
          </Box>
        )}
      </>
    </Box>
  );
};
export default ReviewsGrid;
